// extracted by mini-css-extract-plugin
export var actions = "_qq-4";
export var item = "_qq-1";
export var price = "_qq-3";
export var quantity = "_qq-2";
export var table = "_qq-0";